import React from "react";
import { Container } from "react-bootstrap";

export const ProductVarieties: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                Product Varieties
            </Container>
        </React.Fragment>
    );
}





// import React, { ChangeEvent, useEffect, useState } from "react";
// import { Card, CardBody, Col, Container, Row } from "react-bootstrap";
// import { IQuerySelectData } from "../../../component/solution/Interfaces";
// import { useAuth } from "../../../contexts/AuthContext";
// import { ArrowLeft, FileText, ImageOff, UploadCloud } from "lucide-react";
// import { formatDateFull } from "../../../component/solution/utils/AppUtil";
// import { color } from "echarts";


// interface IVariantItem {
//   id: string;
//   colour: string;
//   size: string;
//   item_asset_id: string;
//   price: number;
//   name: string;
//   item_base_id: string;
//   sku: string;
//   in_stock: number;
//   item_asset_url: string;
//   dirty: boolean;
//   touched: string;
//   created: string;
//   updated: string | null;
// }

// export const ProductVarieties: React.FC = () => {

//      const { fetchData }  = useAuth();
//      const queryUrlSelectIncludeCount: string = `${process.env.REACT_APP_BASE_URL}/${"query/select/data?includeCount=true"}`;
    
//      const [tableRows, setTableRows] = useState<React.ReactElement[]>([]);
//      const [viewMode, setViewMode] = useState<'edit' | 'default'>('default'); 

//      const defaultQueryState: IQuerySelectData = {
//         appCode: "ecom",
//         selectCode: "item_list",  
//         where: "",  
//         orderBy: "",
//         pageNum: 0,
//         pageSize: 100,
//     };    

//     const [queryState, setQueryState] = useState<IQuerySelectData>(defaultQueryState);

//     const defaultSearchState = {
//           name: "",
//           size: "",
//           colour: "", 
//           price: "", 
//           sku: "", 
//           in_stock: "",
//           created: "",
//           updated: "",
//     };
    
//     const [searchState, setSearchState] = useState<{ [key: string]: string }>(defaultSearchState);

//     const [selectedVariantItem, setSelectedVariantItem] = useState<IVariantItem[]>([]);

//     const [queryLineState, setQueryLineState] = useState<IQuerySelectData>({
//         appCode: "ecom",
//         selectCode: "item_list",  
//         where: "", 
//         orderBy: "",
//         pageNum: 0,
//         pageSize: 100,
//     });

    
//     //Pagination 
//     const [pageNumber, setPageNumber] = useState<number>(0); 
//     const [pageSize, setPageSize] = useState<number>(100);   
//     const [totalRecords, setTotalRecords] = useState<number>(0);
//     const [totalPages, setTotalPages] = useState<number>(0);


//     //Testing something with multiple images 
//     const [newImages, setNewImages] = useState<File[]>([]);
//     const [previewUrls, setPreviewUrls] = useState<string[]>([]);


//     useEffect(() => {
//         if(viewMode === "default"){
//             fetchVairents();
//         }
//     }, [queryState, viewMode]);

//     // Pagination updates
//     useEffect(() => {
//         setQueryState(prev => ({
//             ...prev,
//             pageNum: pageNumber,
//             pageSize: pageSize,
//         }));
//     }, [pageNumber, pageSize]);

//     useEffect(() => {
//         return () => {
//             previewUrls.forEach((url) => URL.revokeObjectURL(url));
//         };
//     }, [previewUrls]);

//     const fetchVairents = () => {
//         fetchData(queryUrlSelectIncludeCount, {method:"POST", body: JSON.stringify(queryState)}, processData );
//     }

//     const processData = (result: any) => {

//         const data: IVariantItem[] = [];

//         for (const key in result.data) {
//             const item = result.data[key];
//             data.push({ ...item.data, ...item.control, id: item.id });
//         }

//         //setBaseItem(data);
//         setTableRows(buildTableRows(data));

//         // Pagination 
//         setPageSize(pageSize);
//         setTotalRecords(result?.numRecords);
//         setTotalPages(Math.ceil(result?.numRecords / pageSize));
//     }

//     const processLineData = (result: any) => {
//            console.log(`This is the line data result`, result);
//            const data: IVariantItem[] = [];

//             for (const key in result.data) {
//                 const item = result.data[key];
//                 data.push({ ...item.data, ...item.control, id: item.id });
//             }

//             // Set all variant items
//             setSelectedVariantItem(data);
//     }


//     const handleSelectedItem = ( item_id: string) => {
          
//         const updatedQueryState: IQuerySelectData = {
//             ...queryLineState,
//             selectCode: 'item_assets', // Updated selectCode
//             where: 'id = :id',         // Use placeholder for parameter
//             params: { id: item_id },   // Inject parameter value here
//          };

//         fetchData(queryUrlSelectIncludeCount, { method: "POST", headers: { "Content-Type": "application/json"}, body: JSON.stringify(updatedQueryState)}, processLineData);
//         setViewMode("edit");
//     }

       
//     const buildTableRows = (data: IVariantItem[]): React.ReactElement[] => {
//         const rowElements: React.ReactElement[] = [];

//         const cellStyle: React.CSSProperties = { border: '1px solid #deebed', whiteSpace: 'nowrap', padding: '5px 8px', fontSize: '0.75rem', verticalAlign: 'middle' };

//         data.forEach((record, index) => {
//         const { id, name, size, colour, price, sku, in_stock , item_asset_id , item_asset_url, created, updated } = record;
//         rowElements.push(
//              <tr id={`${index}`} key={id}>
//                  <td style={cellStyle}>
//                     <div className="table-image-container" onClick={() => { handleSelectedItem(id) }}  style={{cursor: 'pointer'}}>
//                         {item_asset_url ? (
//                         <img
//                             src={item_asset_url}
//                             alt={name}
//                             title={name} 
//                             style={{ height: '100%', width: 'auto', borderRadius: '4px', objectFit: 'contain' }}
//                             onError={(e) => (e.currentTarget.style.display = 'none')} 
//                         />
//                         ) : (
//                         <ImageOff size={24} color="#ccc" />
//                         )}
//                     </div>
//                 </td>    
//                 <td style={cellStyle} title={sku}>
//                 {sku}
//                 </td>     
//                 <td style={cellStyle} title={name}>
//                 {name}
//                 </td>
//                 <td style={cellStyle} title={colour}>
//                 {colour}
//                 </td>
//                 <td style={cellStyle} title={size}>
//                 {size}
//                 </td>
//                 <td style={cellStyle} title={price.toString()}>
//                 {price}
//                 </td>
//                 <td style={cellStyle} title={in_stock.toString()}>
//                 {in_stock}
//                 </td>
//                 <td style={cellStyle} title={formatDateFull(created)}>
//                     {formatDateFull(created)}
//                 </td>
//                 <td style={cellStyle} title={formatDateFull(updated ?? "")}>
//                     {formatDateFull(updated ?? "")}
//                 </td> 
//                 <td style={cellStyle} >
//                     <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title='View'
//                      onClick={() => { handleSelectedItem(id) }} 
//                     >
//                         <FileText style={{ width: "20px", height: "20px" }}  /> 
//                     </button>
//                 </td> 
//             </tr>
//           );
//         });
//         return rowElements;
//     };

    

//      const handleSearchOnChange = (event: ChangeEvent<HTMLInputElement>) => {
//         const { id, value } = event.target;
//         setSearchState((prev) => ({ ...prev, [id]: value.trim() }));
//      };
    
//      function parseDate(value: string): string {
//         const trimmed = value.trim();
//         let date: Date | null = null;
    
//         // Try to match known patterns
//         const matchDdMmYyyy = /^\d{2}-\d{2}-\d{4}/.test(trimmed);
//         const matchYyyyMmDd = /^\d{4}-\d{2}-\d{2}/.test(trimmed);
    
//         if (matchDdMmYyyy) {
//           const [day, month, year] = trimmed.split(/[- ]/);
//           date = new Date(`${year}-${month}-${day}`);
//         } else if (matchYyyyMmDd) {
//           date = new Date(trimmed.split(' ')[0]);
//         }
    
//         return date && !isNaN(date.getTime())
//           ? date.toISOString().split('T')[0] // Format as yyyy-mm-dd
//           : value;
//       }
    
//       const generateWhereClause = (search: { [key: string]: string }) => {
//         const clauses = Object.entries(search)
//           .filter(([_, value]) => value.trim() !== "")
//           .map(([key, value]) => {
//             if (key === "created" || key === "updated") {
//               const parsedDate = parseDate(value);
//               return `${key}::date = '${parsedDate.replace(/'/g, "''")}'`;
//             } else {
//               return `${key} ILIKE '%${value.replace(/'/g, "''")}%'`;
//             }
//           });
//         return clauses.join(" AND ");
//       };
    
//        const searchClicked = () => {
//         // Reset pagination state
//         setPageNumber(0); // Reset page to first page
//         setPageSize(100); // Reset page size to 100
    
//         const whereClause = generateWhereClause(searchState);
    
//         setQueryState(prev => ({
//           ...prev,
//           where: whereClause,
//           pageNum: 0, // Ensure that the query state reflects the reset page number
//           pageSize: 100, // Ensure the query state reflects the reset page size
//         }));
//      };
       
//     const clearSearchClicked = () => {
//         setSearchState(defaultSearchState);
//         setQueryState(defaultQueryState);
//     }    


//     // Pagination handlers
//     const goToFirstPage = () => setPageNumber(0);
//     const goToPreviousPage = () => setPageNumber(prev => prev - 1);
//     const goToNextPage = () => setPageNumber(prev => prev + 1);
//     const goToLastPage = () => setPageNumber(totalPages - 1);

//     // Update page size handler
//     const handlePageSizeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
//         const newSize = parseInt(event.target.value, 10);
//         setPageSize(newSize);
//     };


//     const thStyle = {
//          backgroundColor: '#293042',
//          border: '1px solid #deebed',
//          fontWeight: 600,
//          color:'white',
//          padding: '12px 8px', 
//          fontSize: '0.75rem'
//     };

//     const thControlsStyle = {
//         textWrap: 'nowrap',
//         backgroundColor: 'white', 
//         border: '1px solid #deebed',
//         display: 'flex', 
//         justifyContent: 'center', 
//         alignItems: 'center',
//         padding:'2px 0px',
//         margin: '0px'

//     };

//     const thSearchStyle = {
//         textWrap: 'nowrap',
//         backgroundColor: 'white', //lightgray //white
//         border: '1px solid #deebed',
//         padding: '8px 4px'
//     };


//     // Fields used for rendering the column-specific search inputs in the table header
//     const searchFields = [
//         { name: 'sku', placeholder: 'Search SKU...' },
//         { name: 'name', placeholder: 'Search Name...' },
//         { name: 'colour', placeholder: 'Search Colour...' },
//         { name: 'size', placeholder: 'Search Size...' },
//         { name: 'price', placeholder: 'Search Price...' },
//         { name: 'in_stock', placeholder: 'Search In Stock...' },
//         { name: 'created', placeholder: 'Search Created Date...' },
//         { name: 'updated', placeholder: 'Search Updated Date...' },
//     ];

//     // Column headers used to render the table column labels in the main table head
//     const columnHeaders = [
//         { key: 'image', label: 'Image' },
//         { key: 'sku', label: 'SKU' },
//         { key: 'name', label: 'Name' },
//         { key: 'colour', label: 'Colour' },
//         { key: 'size', label: 'Size' },
//         { key: 'price', label: 'Price' },
//         { key: 'in_stock', label: 'In Stock' },
//         { key: 'created', label: 'Created' },
//         { key: 'updated', label: 'Updated' },
//         { key: 'actions', label: 'Actions' },
//     ];


//     return(
//         <React.Fragment>
//             <Container fluid className="p-0">
//                 {viewMode === "default" && 
//                  <Card>
//                   <Card.Header style={{padding: "15px 0px 0px 20px"}}>
//                       <Card.Title>{"Product Varients"}</Card.Title>               
//                   </Card.Header>
//                   <CardBody>
//                         <div className="d-flex flex-wrap align-items-center justify-content-between mr-2 ml-2 mb-2">
//                             <div className="d-flex flex-row gap-2 mt-3">
//                                 <h6 className="card-subtitle text-muted">Total Records: {totalRecords}</h6>
//                                 <h6 className="card-subtitle text-muted">Current Page : [ { pageNumber + 1 } of {totalPages} ]</h6>
//                             </div>

//                             <div className="d-flex align-items-center gap-3">
//                                 {/* // Page Size */}
//                                 <nav aria-label="">
//                                     <ul className="pagination m-0">
//                                         <li className="page-item">
//                                             <select className="page-link" 
//                                                 value={pageSize}
//                                                 onChange={handlePageSizeChange}
//                                                 style={{width: '100px', textAlign: 'center', padding: '10px'}}>
//                                                 <option defaultChecked value={pageSize}>{pageSize}</option>
//                                                 {[25, 50, 75, 100, 150, 200, 250, 500, 750, 1000].map(size => (
//                                                   <option key={size} value={size}>{size}</option>
//                                                 ))}
//                                             </select>
//                                         </li>                            
//                                     </ul>
//                                 </nav>

//                                 {/* // Pagination Control */}
//                                 <nav aria-label="">
//                                     <ul className="pagination m-0">
//                                     <li className={`page-item ${pageNumber === 0 ? 'disabled' : ''}`}>
//                                         <button 
//                                             className="page-link" 
//                                             onClick={goToFirstPage}
//                                             disabled={pageNumber === 0}
//                                             style={{fontSize: '20px', padding: "0px 8px 4px 8px", color: pageNumber === 0 ? "gray" : "black"}}
//                                         >
//                                             |&larr;
//                                         </button>
//                                     </li>
//                                     <li className={`page-item ${pageNumber <= 0 ? 'disabled' : ''}`}>
//                                         <button 
//                                             className="page-link" 
//                                             onClick={goToPreviousPage}
//                                             disabled={pageNumber <= 0}
//                                             style={{fontSize: '20px', padding: "0px 8px 4px 8px", color: pageNumber <= 0 ? "gray" : "black"}}
//                                         >
//                                             &larr;
//                                         </button>
//                                     </li>
//                                     <li className="page-item">
//                                         <span className="page-link" style={{ padding: "8px 14px 8px 14px"}}>
//                                             Page {pageNumber + 1} of {totalPages}
//                                         </span>
//                                     </li>
//                                     <li className={`page-item ${pageNumber >= totalPages - 1 ? 'disabled' : ''} `}>
//                                         <button 
//                                             className="page-link" 
//                                             onClick={goToNextPage}
//                                             disabled={pageNumber >= totalPages - 1}
//                                             style={{fontSize: '20px', padding: "0px 8px 4px 8px", color: pageNumber >= totalPages - 1 ? "gray" : "black"}}
//                                         >
//                                             &rarr;
//                                         </button>
//                                     </li>
//                                     <li className={`page-item ${pageNumber >= totalPages - 1  ? 'disabled' : ''}`}>
//                                         <button 
//                                             className="page-link" 
//                                             onClick={goToLastPage}
//                                             disabled={pageNumber >= totalPages - 1}
//                                             style={{fontSize: '20px', padding: "0px 8px 4px 8px", color: pageNumber >= totalPages - 1 ? "gray" : "black"}}
//                                         >
//                                             &rarr;|
//                                         </button>
//                                     </li>
//                                     </ul>
//                                 </nav>

//                             </div>
//                         </div> 

//                        <div className="sa-table-container" >
//                         <table className="table table-bordered sa-table">
//                             <>
//                             <thead className="sa-list-search">
//                                 <tr>
//                                     <td className="sa-search-control" style={thSearchStyle}></td>   
//                                     { searchFields.map(({ name, placeholder }) => (
//                                         <td key={name} className="sa-search-control" style={thSearchStyle}>
//                                           <input id={name} name={name} value={searchState[name] ?? ''} onChange={handleSearchOnChange} type="text" autoComplete="off"  placeholder={placeholder} className="form-control" />
//                                         </td>
//                                     ))}
//                                     <td style={thControlsStyle}  className="sa-search-control">
//                                         <button onClick={searchClicked} type="button" style={{border:'1px solid rgb(222, 235, 237)', backgroundColor: 'white', borderRadius: '5px', margin: '1px' }}>
//                                         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#495057" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="" style={{width: '34px', height: '34px', margin: "0px", padding:"2px"}}>
//                                             <circle cx="11" cy="11" r="8"></circle>
//                                             <path d="m21 21-4.3-4.3"></path>
//                                         </svg>
//                                         </button >   
//                                         <button onClick={clearSearchClicked} type="button" style={{ border:'1px solid rgb(222, 235, 237)', backgroundColor: 'white', borderRadius: '5px', margin: '1px' }}>
//                                             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#495057" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="" style={{width: '34px', height: '34px', margin: "0px"}}>
//                                                 <path d="M18 6 6 18"></path>
//                                                 <path d="m6 6 12 12"></path>
//                                             </svg>
//                                         </button> 
//                                     </td>
//                                 </tr> 
//                             </thead>
//                             </>

//                             <>
//                             <thead className="sa-list-columns">
//                                 <tr>
//                                     { columnHeaders.map(({ key, label }) => (
//                                         <th key={key} style={thStyle}>{label}</th>
//                                     ))}
//                                 </tr> 
//                             </thead>
//                             </>
//                             <tbody>
//                                 {tableRows}
//                             </tbody>
//                         </table>  
//                         </div>
//                   </CardBody>
//                 </Card>
//                 }

//                 { viewMode === "edit" && 
//                  <Card>
//                   <Card.Header style={{ padding: "15px 20px 0px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                     <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                       <button
//                         className="btn btn-light"
//                         title="Back To Products"
//                         style={{ borderRadius: "50%", padding: "6px", display: "flex", alignItems: "center", justifyContent: "center",  boxShadow: "0 1px 4px rgba(0,0,0,0.1)", border: '1px solid #cfd0d1' }}
//                         onClick={() => {
//                           setViewMode("default");
//                           setSelectedVariantItem([]);
//                           setPreviewUrls([]);
//                           setNewImages([]);
//                         }}
//                       >
//                         <ArrowLeft size={18} />
//                       </button>
//                       <Card.Title style={{ margin: 0 }}>Edit Product Variant</Card.Title>
//                     </div>

//                     {/* <button className="btn btn-light" style={{ marginRight: "0px", border: '1px solid #cfd0d1' }}>
//                       Save
//                     </button> */}
//                   </Card.Header>
//                    <Card.Body style={{ backgroundColor: "#eff2f6", borderRadius: "0 0 0.5rem 0.5rem", margin:'10px 4px 4px 4px', border:'1px solid #e1e5ec'}}>
//                       <p className="text-muted mb-4" style={{paddingLeft: "4px"}}>You are in product variant viewing mode...</p>

//                        {selectedVariantItem.length > 0 && (
//                         <div className="row">
//                             {/* Left column: Shared Variant Info */}
//                             <div className="col-md-6">
//                             {/* Name */}
//                             <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem", border: '1px solid #e1e5ec' }}>
//                                 <label htmlFor="variantName" className="form-label fw-semibold">Name</label>
//                                 <input
//                                 type="text"
//                                 className="form-control"
//                                 value={selectedVariantItem[0].name}
//                                 id="variantName"
//                                 placeholder="Enter variant name"
//                                 disabled
//                                 />
//                             </div>

//                             {/* SKU */}
//                             <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem", border: '1px solid #e1e5ec' }}>
//                                 <label htmlFor="variantSku" className="form-label fw-semibold">SKU</label>
//                                 <input
//                                 type="text"
//                                 className="form-control"
//                                 value={selectedVariantItem[0].sku}
//                                 id="variantSku"
//                                 placeholder="Enter variant SKU"
//                                 disabled
//                                 />
//                             </div>

//                             {/* Colour */}
//                             <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem", border: '1px solid #e1e5ec' }}>
//                                 <label htmlFor="variantColour" className="form-label fw-semibold">Colour</label>
//                                 <input
//                                 type="text"
//                                 className="form-control"
//                                 value={selectedVariantItem[0].colour}
//                                 id="variantColour"
//                                 placeholder="Enter variant colour"
//                                 disabled
//                                 />
//                             </div>

//                             {/* Size */}
//                             <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem", border: '1px solid #e1e5ec' }}>
//                                 <label htmlFor="variantSize" className="form-label fw-semibold">Size</label>
//                                 <input
//                                 type="text"
//                                 className="form-control"
//                                 value={selectedVariantItem[0].size}
//                                 id="variantSize"
//                                 placeholder="Enter variant size"
//                                 disabled
//                                 />
//                             </div>

//                             {/* Price */}
//                             <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem", border: '1px solid #e1e5ec' }}>
//                                 <label htmlFor="variantPrice" className="form-label fw-semibold">Price</label>
//                                 <input
//                                 type="number"
//                                 className="form-control"
//                                 value={selectedVariantItem[0].price}
//                                 id="variantPrice"
//                                 placeholder="Enter variant price"
//                                 disabled
//                                 />
//                             </div>

//                             {/* In Stock */}
//                             <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem", border: '1px solid #e1e5ec' }}>
//                                 <label htmlFor="variantInStock" className="form-label fw-semibold">In Stock</label>
//                                 <input
//                                 type="number"
//                                 className="form-control"
//                                 value={selectedVariantItem[0].in_stock}
//                                 id="variantInStock"
//                                 placeholder="Enter stock quantity"
//                                 disabled
//                                 />
//                             </div>
//                             </div>

//                             {/* Right column: Variant Images + Upload */}
//                             <div className="col-md-6">
//                                 <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem", border: '1px solid #e1e5ec' }}>
//                                     {/* Variant Images Label */}
//                                     <label className="form-label fw-semibold">Variant Images</label>
                                    
//                                     <div
//                                     className="d-flex flex-wrap gap-2"
//                                     style={{
//                                         backgroundColor: "#f9f9f9", // Same background as the input fields
//                                         padding: "1rem",
//                                         borderRadius: "0.5rem",
//                                         border: "1px solid #e1e5ec",
//                                         flexDirection: 'column', // Stack the children vertically
//                                     }}
//                                     >
//                                     {/* Image List */}
//                                     <div className="d-flex flex-wrap gap-2">
//                                         {selectedVariantItem.map((variant, idx) => (
//                                         <div
//                                             key={variant.id || idx}
//                                             className="position-relative"
//                                             style={{
//                                             width: '100px',
//                                             height: '100px',
//                                             overflow: 'hidden',
//                                             borderRadius: '6px',
//                                             border: '1px solid #ddd',
//                                             }}
//                                         >
//                                             <img
//                                             src={variant.item_asset_url}
//                                             alt={`Variant ${idx + 1}`}
//                                             style={{
//                                                 width: '100%',
//                                                 height: '100%',
//                                                 objectFit: 'cover',
//                                                 borderRadius: '6px',
//                                                 transition: 'transform 0.3s ease',
//                                             }}
//                                             onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.2)')}
//                                             onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//                                             />
//                                         </div>
//                                         ))}
//                                     </div>

//                                     {previewUrls.length > 0 && (
//                                     <div style={{ backgroundColor: '#edeef0', padding: '4px', marginTop: '3px', borderRadius: '0.5rem' }}>
//                                         {/* Message above images */}
//                                         <small className="text-muted d-block mb-2">Collection of images to upload.</small>

//                                         {/* Images in a row */}
//                                         <div className="d-flex flex-wrap gap-2">
//                                         {previewUrls.map((url, idx) => (
//                                             <div key={url} style={{ position: 'relative', width: '100px', height: '100px' }}>
//                                             <img src={url} alt={`Preview ${idx}`}
//                                                 style={{ width: '100%',  height: '100%', objectFit: 'cover',  borderRadius: '6px', border: '1px dashed #aaa'}}
//                                             />
//                                             <button type="button"
//                                                 onClick={() => {
//                                                 setPreviewUrls((prev) => prev.filter((_, i) => i !== idx));
//                                                 setNewImages((prev) => prev.filter((_, i) => i !== idx));
//                                                 }}
//                                                 style={{
//                                                 position: 'absolute',
//                                                 top: 0,
//                                                 right: 0,
//                                                 background: 'rgba(255, 255, 255, 0.8)',
//                                                 border: 'none',
//                                                 borderRadius: '50%',
//                                                 width: '24px',
//                                                 height: '24px',
//                                                 cursor: 'pointer',
//                                                 fontWeight: 'bold',
//                                                 color: '#333',
//                                                 }}
//                                             >
//                                                 ×
//                                             </button>
//                                             </div>
//                                         ))}
//                                         </div>
//                                     </div>
//                                     )}



//                                     {/* Upload New Image Block */}
//                                      <div className="d-flex gap-2 mt-1 align-items-start">
//                                         {/* Upload Box */}
//                                         <label htmlFor="upload-image"
//                                             className="border border-secondary-subtle rounded text-center d-flex flex-column align-items-center justify-content-center"
//                                             style={{ width: '100px', height: '100px', cursor: 'pointer', backgroundColor: '#f8f9fa',borderStyle: 'dashed'}}
//                                         >
//                                             <UploadCloud size={24} color="#666" style={{ marginBottom: '4px' }} />
//                                             <small className="text-muted">Upload Image</small>
//                                         </label>

//                                         <input id="upload-image" type="file" accept="image/*" multiple style={{ display: "none" }}
//                                             onChange={(e) => {
//                                                 const files = Array.from(e.target.files || []);
//                                                 const previews = files.map((file) => URL.createObjectURL(file));
//                                                 setNewImages((prev) => [...prev, ...files]);
//                                                 setPreviewUrls((prev) => [...prev, ...previews]);
//                                             }}
//                                         />

//                                         {/* Save Button */}
//                                         {previewUrls.length > 0 && (
//                                             <button type="button" className="btn btn-light"
//                                              style={{ height: '100px', width: '100px', borderRadius: '0.5rem', fontWeight: '500', color: 'grey', border: '1px solid grey'}}
//                                             >
//                                             Save Images
//                                             </button>
//                                         )}
//                                         </div>

//                                     {/* Additional Message */}
//                                     <small className="text-muted d-block mt-1">
//                                         You can upload a new image to replace the existing one
//                                     </small>
//                                     </div>
//                                 </div>
//                             </div>

//                         </div>
//                         )}

//                     </Card.Body>
//                  </Card>
//                 }
//             </Container>
//         </React.Fragment>
//     );
// }